import React from 'react';
import styled from 'styled-components';
import { Typography } from '@vp/react-vp-ui-library';

const SlideTitle = styled(Typography)`
  margin-bottom: 0;
`;

const SlideSubTitle = styled(Typography)`
  color: rgb(151, 151, 151);
  margin: 0;
`;

const SlidePrice = styled(Typography)`
  background-color: white;
  border-radius: 10px;
  padding: 2px 8px 0 8px;
  margin-top: 12px;
  font-size: 14px;
`;

const SlideAction = styled.button`
  border: none;
  color: rgb(24, 154, 221);
  background-color: transparent;
  margin-top: 20px;
  margin-bottom: 4px; /* add margin so that border isn't cut off */

  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

interface SlideProps {
  image: React.ReactNode;
  title: React.ReactNode;
  subTitle: React.ReactNode;
  price: React.ReactNode;
  action: React.ReactNode;
}

export default function Slide(props: SlideProps) {
  const { image, title, subTitle, price, action } = props;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          height: 220,
        }}
      >
        {image}
      </div>
      <SlideTitle>{title}</SlideTitle>
      <SlideSubTitle size={6}>{subTitle}</SlideSubTitle>
      <SlidePrice size={6}>{price}</SlidePrice>
      <SlideAction>{action}</SlideAction>
    </div>
  );
}
